import { get, writable } from "svelte/store";
function readStoredTheme() {
    try {
        return localStorage.getItem("theme");
    }
    catch {
        return null;
    }
}
export const theme = writable(readStoredTheme() || "system");
export const setBodyThemeClassName = (theme) => {
    const classToRemove = theme === "dark" ? "light" : "dark";
    document.documentElement.classList.add("no-transition");
    document.documentElement.classList.remove(`psx-${classToRemove}`);
    document.documentElement.classList.add(`psx-${theme}`);
    setTimeout(() => {
        document.documentElement.classList.remove("no-transition");
    }, 1);
};
theme.subscribe((value) => {
    if (typeof window === "undefined")
        return;
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (value === "system") {
        setBodyThemeClassName(prefersDark ? "dark" : "light");
    }
    else {
        setBodyThemeClassName(value);
    }
    try {
        localStorage.setItem("theme", value);
    }
    catch {
        /* ignore (private browsing, no-storage env) */
    }
});
export const setBodyThemeClassFromMediaQuery = (event) => {
    if (get(theme) === "system") {
        setBodyThemeClassName(event.matches ? "dark" : "light");
    }
};
